/**
 * 工具函数封装
 */

let timeout = null;
/**
 * 防抖原理：就是当一个操作连续执行了很多次，但是代码只执行最后一次。（一定时间内，只有最后一次操作，再过wait毫秒后才执行函数）
 *
 * @param {Function} func 要执行的回调函数
 * @param {Number} wait 延时的时间
 * @param {Boolean} immediate 是否立即执行
 * @return null
 * * debounce(()=> {
 *   #codeing
 * }, 1000)
 */
export function debounce(func, wait = 500, immediate = false) {
	// 清除定时器
	if (timeout !== null) clearTimeout(timeout);
	// 立即执行，此类情况一般用不到
	if (immediate) {
		var callNow = !timeout;
		timeout = setTimeout(function () {
			timeout = null;
		}, wait);
		if (callNow) typeof func === "function" && func();
	} else {
		// 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
		timeout = setTimeout(function () {
			typeof func === "function" && func();
		}, wait);
	}
}

let timer, flag;
/**
 * 节流原理：触发函数之后，短时间内不能再次调用，只有上一次函数执行完毕，过了规定的间隔才能下一次调用。（在一定时间内，只能触发一次，按照一定的频率触发）
 *
 * @param {Function} func 要执行的回调函数
 * @param {Number} wait 延时的时间
 * @param {Boolean} immediate 是否立即执行
 * @return null
 * * throttle(()=> {
 *     #codeing
 * }, 1000)
 */
export function throttle(func, wait = 500, immediate = true) {
	if (immediate) {
		if (!flag) {
			flag = true;
			// 如果是立即执行，则在wait毫秒内开始时执行
			typeof func === "function" && func();
			timer = setTimeout(() => {
				flag = false;
			}, wait);
		}
	} else {
		if (!flag) {
			flag = true;
			// 如果是非立即执行，则在wait毫秒内的结束处执行
			timer = setTimeout(() => {
				flag = false;
				typeof func === "function" && func();
			}, wait);
		}
	}
}

/**
 * 获取浏览器参数
 **/
export function getUrlKey(name) {
	return (
		decodeURIComponent(
			(new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
				decodeURIComponent(location.href)
			) || [, ""])[1].replace(/\+/g, "%20")
		) || null
	);
}

// 是否进行搜索
// 参数一为要添加的对象，参数二为要检测的对象
export function canSearch(addObj, data) {
	var num = 0;
	Object.keys(data).forEach((item) => {
		if (addObj[item] === undefined) {
			addObj[item] = data[item];
			num = 1;
		} else {
			//  如果addObj身上有该属性的话判断是不是数组
			if (Array.isArray(data[item])) {
				if (addObj[item] == null) {
					addObj[item] = [];
				}

				if (
					addObj[item][0] != data[item][0] ||
					addObj[item][1] != data[item][1]
				)
					num++;
				addObj[item] = [...data[item]];
			} else {
				if (addObj[item] != data[item]) num++;
				addObj[item] = data[item];
			}
		}
	});
	return num == 0;
}
